import { UserLayout, BasicLayout, RouteView, BlankLayout, PageView } from '@/layouts'
import { bxAnaalyse } from '@/core/icons'
import configRouters from './modules'

const constantRouterComponents = {
  // 基础页面 layout 必须引入
  BasicLayout: BasicLayout,
  BlankLayout: BlankLayout,
  RouteView: RouteView,
  PageView: PageView
}

export const staticRouterMap = [
  // dashboard
  {
    path: '/dashboard/workplace',
    name: 'dashboard',
    component: () => import('../views/dashboard/Workplace'),
    meta: { title: '工作台', icon: 'appstore' }
  },
  // account
  {
    path: '/account',
    component: RouteView,
    hidden: true,
    meta: { title: '个人中心', keepAlive: true },
    children: [
      {
        path: '/account/settings',
        name: 'settings',
        component: () => import('@/views/account/settings/Index'),
        meta: { title: '个人设置', hideHeader: true, keepAlive: true },
        redirect: '/account/settings/base',
        alwaysShow: true,
        children: [
          {
            path: '/account/settings/base',
            name: 'BaseSettings',
            component: () => import('@/views/account/settings/BaseSetting'),
            meta: { title: '基本设置', hidden: true, keepAlive: true }
          },
          {
            path: '/account/settings/security',
            name: 'SecuritySettings',
            component: () => import('@/views/account/settings/Security'),
            meta: { title: '安全设置', hidden: true, keepAlive: true }
          },
          {
            path: '/account/settings/custom',
            name: 'CustomSettings',
            component: () => import('@/views/account/settings/Custom'),
            meta: { title: '个性化设置', hidden: true, keepAlive: true }
          },
          {
            path: '/account/settings/binding',
            name: 'BindingSettings',
            component: () => import('@/views/account/settings/Binding'),
            meta: { title: '账户绑定', hidden: true, keepAlive: true }
          },
          {
            path: '/account/settings/notification',
            name: 'NotificationSettings',
            component: () => import('@/views/account/settings/Notification'),
            meta: { title: '新消息通知', hidden: true, keepAlive: true }
          }
        ]
      }
    ]
  },
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/Login')
  },
  {
    path: '/expertLogin',
    name: 'expertLogin',
    component: () => import('../views/login/LoginIt')
  },
  {
    path: '/portalLogin',
    name: 'portalLogin',
    component: () => import('../views/login/PortalLogin')
  },
  // 微信网页授权界面
  {
    path: '/loginByWeChat',
    name: 'loginByWeChat',
    component: () => import('../views/login/WeChatAuth')
  },
  // {
  //   path: '/oaLogin',
  //   name: 'oaLogin',
  //   component: () => import('../views/login/OALogin')
  // },
  // 专家H5界面
  {
    path: '/expertWeixMappage',
    name: 'expertWeixMapPage',
    hidden: true,
    component: () => import('@/epp/weixmap/ExpertWeixMapPage.vue'),
    meta: { title: '首页', icon: 'appstore' }
  },
  {
    path: '/index',
    name: 'index',
    redirect: '/dashboard/workplace',
  },
  {
    path: '/oauth-callback',
    name: 'oAuthCallback',
    component: () => import('../views/login/OAuthCallback')
  },
  {
    path: '/oauth-callback-login',
    name: 'oAuthCallbackLogin',
    component: () => import('../views/login/OAuthCallbackLogin')
  },
  {
    path: '/404',
    component: () => import('../views/exception/404')
  },
  {
    path: '/',
    redirect: '/dashboard/workplace',
    name: '首页',
    hidden: true
  },
  {
    path: '/workflow/design/add',
    name: 'WorkflowDesignAdd',
    component: () => import('../views/workflow/design/editor/WFAddFull')
  },
  {
    path: '/expert/applyfor',
    name: 'expertApplyFor',
    component: () => import('@/epp/expertmain/expertInfo/common/ExpertApplyFor.vue')
  },
  {
    path: '/expert/item/replace',
    name: 'itemReplace',
    hidden: false,
    component: () =>
      import('@/epp/expertmain/expertInfo/replace/ExpertItemReplace.vue')
  },
]

// 递归构建子菜单
function builderChildrenRouter (routerMap, parentRouter) {
  const accessedRouters = routerMap.map(item => {
    let path = item.path
    if (item.view === '@/views/iframe/IframeView') {
      if (parentRouter != null) {
        path = parentRouter.path + '/' + item.id
      } else {
        path = item.id
      }
    }
    if (item.view && !path) {
      path = item.id
    }
    const currentRouter = {
      // 路由地址结果 eg: /dashboard/analysis
      path: path,
      name: item.id,
      // 页面标题, 菜单图标, 页面权限(供指令权限用，可去掉)
      meta: { title: item.title, icon: item.icon || null, originPath: item.path, target: item.target },
      hidden: item.hidden
    }
    if (item.query) {
      currentRouter.query = item.query
    }
    if (item.children && item.children.length > 0) {
      currentRouter.component = constantRouterComponents[item.component] || (() => import(item.view))
      currentRouter.children = builderChildrenRouter(item.children, item)
    } else {
      currentRouter.component = createComponent(item)
    }
    return currentRouter
  })
  return accessedRouters
}

function createComponent (item) {
  let func = null
  if (item.view.indexOf('@/libs/') === 0) {
    func = () => import('@/libs/' + item.view.substring(7))
  } else if (item.view.indexOf('@/views/') === 0) {
    func = () => import('@/views/' + item.view.substring(8))
  } else if (item.view.indexOf('@/epp/') === 0) {
    func = () => import('@/epp/' + item.view.substring(6))
  }
  return func
}

function mapFxModules (modules) {
  const mappedModules = modules.map(item => {
    const menu = {
      id: item.id,
      path: item.webPath,
      title: item.name,
      icon: item.icon ? item.icon : null,
      view: item.viewTemplate,
      target: item.target === 1,
      hidden: item.state !== '1'
    }
    if (item.cateId) {
      menu.query = { caseTypeId: item.cateId }
    }
    //仅限专家列表，如有冲突请修改
    if (item.webPath.includes(':tag')) {
      menu.query = Object.assign({}, menu.query, { tag: '0' })
      menu.path = item.webPath.replace('/:tag', '')
    }
    if (item.hasChildren) {
      menu.component = 'RouteView'
      menu.children = mapFxModules(item.children)
    }
    return menu
  })

  return mappedModules
}

export function generateModuleRoute (modules) {
  let result = mapFxModules(modules)
  let asyncRouters = result.map(item => {
    let path = item.path
    if (item.view === '@/views/iframe/IframeView') {
      path = item.id
    }
    // 一级菜单
    const currentRouter = {
      path: path,
      name: item.id,
      // 获取页面 layout
      component: constantRouterComponents[item.component] || createComponent(item),
      meta: { title: item.title, icon: item.icon || null, originPath: item.path, target: item.target },
      query: item.query,
      hidden: item.hidden
    }
    // 有子菜单
    if (item.children && item.children.length > 0) {
      currentRouter.children = builderChildrenRouter(item.children, item)
    }
    return currentRouter
  })

  const finalRouter = [
    {
      path: '/',
      component: BasicLayout,
      name: 'dashboard',
      meta: { title: '首页' },
      redirect: '/dashboard/workplace',
      children: staticRouterMap.concat(configRouters).concat(asyncRouters)
    },
    {
      path: '*', redirect: '/404', hidden: true
    }
  ]

  return finalRouter
}

